export const deviceTypesCode = [
    {
        name: "Картходлер",
        value: "CHARTHOLDER",
        img: "cardholder",
        code: 1,
    },
    {
        name: "Выключатель",
        value: "SWITCH",
        img: "switch",
        code: 2,
    },
    {
        name: "Датчик движения",
        value: "MOTION_SENSOR",
        img: "motion_sensor",
        code: 3,
    },
    {
        name: "Датчик открытия",
        value: "OPENING_SENSOR",
        img: "opening_sensor",
        code: 4,
    },
    {
        name: "Вентиляция",
        value: "VENTILATION",
        img: "ventilation",
        code: 5,
    },
    {
        name: "Датчик протечки",
        value: "LEAK_SENSOR",
        img: "leak_sensor",
        code: 6,
    },
    {
        name: "Датчик температуры воздуха",
        value: "AIR_TEMPERATURE_SENSOR",
        img: "thermometer",
        code: 7,
    },
    {
        name: "Шторы с приводом",
        value: "CURTAINS",
        img: "curtains",
        code: 8,
    },
    {
        name: "Освещение",
        value: "LIGHTING",
        img: "lighting",
        code: 9,
    },
    {
        name: "Розетка",
        value: "SOCKET",
        img: "socket",
        code: 10,
    },
    {
        name: "Холодильник",
        value: "FRIDGE",
        img: "fridge",
        code: 11,
    },
    {
        name: "Отопление",
        value: "HEATING",
        img: "heating",
        code: 12,
    },
    {
        name: "Полы с подогревом",
        value: "UNDERFLOOR_HEATING",
        img: "warm_floor",
        code: 13,
    },
    {
        name: "Клапан перекрытия воды",
        value: "WATER_SHUT_OFF",
        img: "water_shut_off",
        code: 14,
    },
    {
        name: "Диммируемое освещение",
        value: "DIMMABLE_LIGHTING",
        img: "lighting",
        code: 15,
    },
    {
        name: "Телевизор",
        value: "TELEVISION",
        img: "tv",
        code: 16,
    },
    {
        name: "Датчик освещения",
        value: "LIGHT_SENSOR",
        img: "light_sensor",
        code: 17,
    },
    {
        name: "Датчик влажности",
        value: "AIR_HUMIDITY_SENSOR",
        img: " humidity_sensor",
        code: 18,
    },
]
export default deviceTypesCode;
